import { lazy, FC, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import TopBarProgress from "react-topbar-progress-indicator";
import { Dashboard } from "../pages/dashboard/Dashboard";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import { WithChildren } from "../../_metronic/helpers";
import { DashboardPlansSeller } from "../pages/dashboard-plans-seller/DashboardPlansSeller";
import { Payments } from "../pages/historic/payments";
import { Access } from "../pages/historic/access";
import { CampeonatoForm } from "../modules/technical-committee/pages/view/campeonato/CampeonatoForm";
import { ConvocacaoForm } from "../modules/technical-committee/pages/view/convocacoes/ConvocacaoForm";
import { AvaliacaoForm } from "../modules/technical-committee/pages/view/avaliacoes/AvaliacaoForm";
import { GerenciarConvocados } from "../modules/technical-committee/pages/view/convocacoes/GerenciarConvocados";

const PrivateRoutes = () => {
  const UsersList = lazy(() => import("../modules/users/pages/UsersList"));
  const UsersCreate = lazy(() => import("../modules/users/pages/UsersCreate"));
  const UsersEdit = lazy(() => import("../modules/users/pages/UsersEdit"));
  const UsersImport = lazy(() => import("../modules/users/pages/UsersImport"));
  
  const EmployeesList = lazy(() => import("../modules/employees/pages/EmployeesList"));
  const EmployeesCreate = lazy(() => import("../modules/employees/pages/EmployeesCreate"));
  const EmployeesEdit = lazy(() => import("../modules/employees/pages/EmployeesEdit"));
  
  const PermissionsCreate = lazy(
    () => import("../modules/permissions/pages/PermissionsCreate"),
  );
  // 🟢 Importando a tela de cobranças da própria empresa
  const CompanyPaymentsCollectiosList = lazy(
    () => import("../modules/collections/CollectiosList"),
  );
  const PermissionsList = lazy(
    () => import("../modules/permissions/pages/PermissionsList"),
  );
  const PermissionsEdit = lazy(
    () => import("../modules/permissions/pages/PermissionsEdit"),
  );
  const RolesList = lazy(() => import("../modules/users/pages/RolesList"));
  const RolesCreate = lazy(() => import("../modules/users/pages/RolesCreate"));
  const RolesEdit = lazy(() => import("../modules/users/pages/RolesEdit"));
  const UserRoles = lazy(() => import("../modules/users/pages/UserRoles"));
  
  const EmployeeRoles = lazy(() => import("../modules/employees/pages/EmployeeRoles"));

  const AddressesList = lazy(
    () => import("../modules/users/pages/addresses/AddressesList"),
  );
  const AddressCreate = lazy(
    () => import("../modules/users/pages/addresses/AddressCreate"),
  );
  const AddressEdit = lazy(
    () => import("../modules/users/pages/addresses/AddressEdit"),
  );
  const UserPermissions = lazy(
    () => import("../modules/users/pages/UserPermissions"),
  );
  const EmployeesPermissions = lazy(
    () => import("../modules/employees/pages/EmployeesPermissions"),
  );
  const UserLocations = lazy(
    () => import("../modules/users/pages/UserLocations"),
  );
  const RolePermissions = lazy(
    () => import("../modules/users/pages/RolePermissions"),
  );

  // 🟢 CORREÇÃO: Adicionando os imports das telas de Contrato que estavam faltando
  const ContractsList = lazy(
    () => import("../modules/contracts/pages/ContractsList"),
  );
  const ContractsCreate = lazy(
    () => import("../modules/contracts/pages/ContractsCreate"),
  );
  const ContractsEdit = lazy(
    () => import("../modules/contracts/pages/ContractsEdit"),
  );

  const ChargesList = lazy(
    () => import("../modules/contracts/charges/pages/ChargesList"),
  );
  const DiscountCouponsList = lazy(
    () => import("../modules/discount-coupons/pages/DiscountCouponsList"),
  );
  const DiscountCouponsCreate = lazy(
    () => import("../modules/discount-coupons/pages/DiscountCouponsCreate"),
  );
  const DiscountCouponsEdit = lazy(
    () => import("../modules/discount-coupons/pages/DiscountCouponsEdit"),
  );
  const DiscountsList = lazy(
    () => import("../modules/discounts/pages/DiscountList"),
  );
  const DiscountsCreate = lazy(
    () => import("../modules/discounts/pages/DiscountCreate"),
  );
  const DiscountsEdit = lazy(
    () => import("../modules/discounts/pages/DiscountEdit"),
  );

  const PlansCreate = lazy(() => import("../modules/plans/pages/PlansCreate"));
  const PlansList = lazy(() => import("../modules/plans/pages/PlansList"));
  const PlansEdit = lazy(() => import("../modules/plans/pages/PlansEdit"));
  const PlansDiscountCoupons = lazy(
    () => import("../modules/plans/pages/PlansDiscountCoupons"),
  );
  const LocationsList = lazy(
    () => import("../modules/locations/pages/LocationsList"),
  );
  const LocationsCreate = lazy(
    () => import("../modules/locations/pages/LocationsCreate"),
  );
  const LocationsEdit = lazy(
    () => import("../modules/locations/pages/LocationsEdit"),
  );
  const TemplatesCreate = lazy(
    () => import("../modules/templates/pages/TemplatesCreate"),
  );
  const TemplatesList = lazy(
    () => import("../modules/templates/pages/TemplatesList"),
  );
  const TemplatesEdit = lazy(
    () => import("../modules/templates/pages/TemplatesEdit"),
  );
  const ModulesCreate = lazy(() => import("../modules/modules/ModulesCreate"));
  const ModulesList = lazy(() => import("../modules/modules/ModulesList"));
  const ModulesEdit = lazy(() => import("../modules/modules/ModulesEdit"));
  const ProfilePage = lazy(
    () => import("../modules/profile/pages/ProfilePage"),
  );
  const SectionsList = lazy(
    () => import("../modules/sections/pages/SectionsList"),
  );
  const SectionsCreate = lazy(
    () => import("../modules/sections/pages/SectionsCreate"),
  );
  const SectionsEdit = lazy(
    () => import("../modules/sections/pages/SectionsEdit"),
  );
  const BraceletColorsList = lazy(
    () => import("../modules/bracelet-colors/pages/BraceletColorsList"),
  );
  const BraceletColorsCreate = lazy(
    () => import("../modules/bracelet-colors/pages/BraceletColorsCreate"),
  );
  const BraceletColorsEdit = lazy(
    () => import("../modules/bracelet-colors/pages/BraceletColorsEdit"),
  );
  const BraceletColorsSections = lazy(
    () => import("../modules/bracelet-colors/pages/BraceletColorsSections"),
  );
  const BraceletColorsLocations = lazy(
    () => import("../modules/bracelet-colors/pages/BraceletColorsLocations"),
  );
  const BraceletsList = lazy(
    () => import("../modules/bracelets/pages/BraceletsList"),
  );
  const BraceletsCreate = lazy(
    () => import("../modules/bracelets/pages/BraceletsCreate"),
  );
  const BraceletsEdit = lazy(
    () => import("../modules/bracelets/pages/BraceletsEdit"),
  );
  const AccessPointsList = lazy(
    () => import("../modules/access-points/pages/AccessPointsList"),
  );
  const AccessPointsCreate = lazy(
    () => import("../modules/access-points/pages/AccessPointsCreate"),
  );
  const AccessPointsEdit = lazy(
    () => import("../modules/access-points/pages/AccessPointsEdit"),
  );

  const GeneralAccessList = lazy(
    () => import("../modules/general-access/pages/GeneralAccessList"),
  );
  const InvoicingPaymentsList = lazy(
    () => import("../modules/invoicing-payments/pages/InvoicingPaymentsList"),
  );

  const TagsList = lazy(() => import("../modules/tags/pages/TagsList"));
  const TagsCreate = lazy(() => import("../modules/tags/pages/TagsCreate"));
  const TagsEdit = lazy(() => import("../modules/tags/pages/TagsEdit"));
  const TemplateTags = lazy(
    () => import("../modules/templates/pages/TemplateTags"),
  );

  const StockList = lazy(() => import("../modules/stock/pages/StockList"));
  const SalesList = lazy(() => import("../modules/sales/pages/SalesList"));
  const NotificationsList = lazy(
    () => import("../modules/notifications/pages/NotificationsList"),
  );
  const MyPlan = lazy(() => import("../modules/my-plan/pages/MyPlan"));
  const TechnicalCommitteeDashboard = lazy(
    () =>
      import(
        "../modules/technical-committee/pages/TechnicalCommitteeDashboard"
      ),
  );
  // 🟢 Substituindo a importação antiga pelo novo componente AthleteCreate em AtletaWizard.tsx
  const AthleteCreate = lazy(
    () =>
      import(
        "../modules/technical-committee/pages/view/athlete-form/AtletaWizard"
      ),
  );
  const CategoriasView = lazy(
    () =>
      import(
        "../modules/technical-committee/pages/view/categorias/CategoriasView"
      ),
  );
  const CategoriasForm = lazy(
    () =>
      import(
        "../modules/technical-committee/pages/view/categorias/CategoriasForm"
      ),
  );
  const PlanosView = lazy(
    () => import("../modules/technical-committee/pages/view/planos/PlanosView"),
  );
  const PlanosForm = lazy(
    () => import("../modules/technical-committee/pages/view/planos/PlanosForm"),
  );

  const SponsorList = lazy(
    () => import("../modules/sponsor/pages/SponsorList"),
  );
  const SponsorForm = lazy(
    () => import("../modules/sponsor/pages/SponsorForm"),
  );

  const SponsorPlan = lazy(
    () => import("../modules/sponsor/pages/SponsorPlan"),
  );
  const SponsorPlanForm = lazy(
    () => import("../modules/sponsor/pages/SponsorPlanForm"),
  );
  const FornecedoresList = lazy(
    () => import("../modules/fornecedores/pages/FornecedoresList"),
  );
  const FornecedoresForm = lazy(
    () => import("../modules/fornecedores/pages/FornecedoresForm"),
  );
  const EstoqueList = lazy(() => import("../modules/estoque/pages/EstoqueList"));
  const SetoresPage = lazy(() => import("../modules/estoque/pages/SetoresPage"));
  const EntradaManualPage = lazy(() => import("../modules/estoque/pages/EntradaManualPage"));
  const SaidaPage = lazy(() => import("../modules/estoque/pages/SaidaPage"));
  const RelatorioPage = lazy(() => import("../modules/estoque/pages/RelatorioPage"));
  const EntradaXmlPage = lazy(() => import("../modules/estoque/pages/EntradaXmlPage"));
  const CardapioList = lazy(() => import("../modules/cardapio/pages/CardapioList"));
  const CardapioForm = lazy(() => import("../modules/cardapio/pages/CardapioForm"));
  const CardapioClientePage = lazy(
    () => import("../modules/cardapio/pages/CardapioClientePage"),
  );
  const CardapioPedidoPage = lazy(
    () => import("../modules/cardapio/pages/CardapioPedidoPage"),
  );
  const CardapioRelatorioPage = lazy(
    () => import("../modules/cardapio/pages/CardapioRelatorioPage"),
  );

  const CaixaDashboardPage = lazy(
    () => import("../modules/caixa-financeiro/pages/CaixaDashboardPage"),
  );
  const AberturaCaixaPage = lazy(
    () => import("../modules/caixa-financeiro/pages/AberturaCaixaPage"),
  );
  const FrenteCaixaPage = lazy(
    () => import("../modules/caixa-financeiro/pages/FrenteCaixaPage"),
  );
  const FechamentoCaixaPage = lazy(
    () => import("../modules/caixa-financeiro/pages/FechamentoCaixaPage"),
  );
  const SangriaPage = lazy(
    () => import("../modules/caixa-financeiro/pages/SangriaPage"),
  );
  const TransacoesPage = lazy(
    () => import("../modules/caixa-financeiro/pages/TransacoesPage"),
  );
  const PagamentosPage = lazy(
    () => import("../modules/caixa-financeiro/pages/PagamentosPage"),
  );
  const PulseirasPage = lazy(
    () => import("../modules/caixa-financeiro/pages/PulseirasPage"),
  );
  const OperadoresPage = lazy(
    () => import("../modules/caixa-financeiro/pages/OperadoresPage"),
  );
  const ComissoesPage = lazy(
    () => import("../modules/caixa-financeiro/pages/ComissoesPage"),
  );
  const RelatoriosCaixaPage = lazy(
    () => import("../modules/caixa-financeiro/pages/RelatoriosPage"),
  );
  const AuditoriaPage = lazy(
    () => import("../modules/caixa-financeiro/pages/AuditoriaPage"),
  );

  // Financeiro - Contas a Pagar e Receber
  const PlanoContasPage = lazy(
    () => import("../modules/contas-pagar-receber/pages/PlanoContasPage"),
  );
  const CentrosCustoPage = lazy(
    () => import("../modules/contas-pagar-receber/pages/CentrosCustoPage"),
  );
  const EntradaContaPagarPage = lazy(
    () => import("../modules/contas-pagar-receber/pages/EntradaContaPagarPage"),
  );
  const EntradaContaReceberPage = lazy(
    () => import("../modules/contas-pagar-receber/pages/EntradaContaReceberPage"),
  );
  const ContasPagarList = lazy(
    () => import("../modules/contas-pagar-receber/pages/ContasPagarList"),
  );
  const ContasReceberList = lazy(
    () => import("../modules/contas-pagar-receber/pages/ContasReceberList"),
  );
  const FluxoCaixaPage = lazy(
    () => import("../modules/contas-pagar-receber/pages/FluxoCaixaPage"),
  );
  const ConciliacaoBancariaPage = lazy(
    () => import("../modules/contas-pagar-receber/pages/ConciliacaoBancariaPage"),
  );
  const DreSimplificadaPage = lazy(
    () => import("../modules/contas-pagar-receber/pages/DreSimplificadaPage"),
  );
  const RelatoriosGerenciaisPage = lazy(
    () => import("../modules/contas-pagar-receber/pages/RelatoriosGerenciaisPage"),
  );

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path="auth/*" element={<Navigate to="/dashboard" />} />
        {/* Pages */}
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="plans-seller" element={<DashboardPlansSeller />} />
        <Route path="payments" element={<Payments />} />
        <Route path="access" element={<Access />} />
        {/* Lazy Modules */}
        <Route
          path="/users"
          element={
            <SuspensedView>
              <UsersList />
            </SuspensedView>
          }
        />
        {/* 🟢 CORREÇÃO: Usando a rota collection */}
        <Route
          path="collection"
          element={
            <SuspensedView>
              <CompanyPaymentsCollectiosList />
            </SuspensedView>
          }
        />
        <Route
          path="/import"
          element={
            <SuspensedView>
              <UsersImport />
            </SuspensedView>
          }
        />
        <Route
          path="/users/create"
          element={
            <SuspensedView>
              <UsersCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/users/:id"
          element={
            <SuspensedView>
              <UsersEdit />
            </SuspensedView>
          }
        />
        {/* 🟢 CORREÇÃO: Rotas de contrato do usuário ativadas */}
        <Route
          path="/users/:userId/contracts"
          element={
            <SuspensedView>
              <ContractsList />
            </SuspensedView>
          }
        />
        <Route
          path="/users/:userId/contracts/create"
          element={
            <SuspensedView>
              <ContractsCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/users/:userId/contracts/:contractId/charges"
          element={
            <SuspensedView>
              <ChargesList />
            </SuspensedView>
          }
        />
        <Route
          path="/users/:id/roles"
          element={
            <SuspensedView>
              <UserRoles />
            </SuspensedView>
          }
        />
        <Route
          path="/users/:id/permissions"
          element={
            <SuspensedView>
              <UserPermissions />
            </SuspensedView>
          }
        />

        <Route
          path="/users/:id/locations"
          element={
            <SuspensedView>
              <UserLocations />
            </SuspensedView>
          }
        />
        <Route
          path="/stock"
          element={
            <SuspensedView>
              <StockList />
            </SuspensedView>
          }
        />
        <Route
          path="/sales"
          element={
            <SuspensedView>
              <SalesList />
            </SuspensedView>
          }
        />
        <Route
          path="/notifications"
          element={
            <SuspensedView>
              <NotificationsList />
            </SuspensedView>
          }
        />
        <Route
          path="/my-plan"
          element={
            <SuspensedView>
              <MyPlan />
            </SuspensedView>
          }
        />
        <Route
          path="/technical-committee"
          element={
            <SuspensedView>
              <TechnicalCommitteeDashboard />
            </SuspensedView>
          }
        />
        <Route
          path="/technical-committee/create"
          element={
            <SuspensedView>
              <AthleteCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/technical-committee/championships/new"
          element={
            <SuspensedView>
              <CampeonatoForm />
            </SuspensedView>
          }
        />
        <Route
          path="/technical-committee/championships/edit/:id"
          element={
            <SuspensedView>
              <CampeonatoForm />
            </SuspensedView>
          }
        />
        <Route
          path="/technical-committee/convocations/new"
          element={
            <SuspensedView>
              <ConvocacaoForm />
            </SuspensedView>
          }
        />
        <Route
          path="/technical-committee/convocations/edit/:id"
          element={
            <SuspensedView>
              <ConvocacaoForm />
            </SuspensedView>
          }
        />

        <Route
          path="/technical-committee/convocations/:id/manage"
          element={
            <SuspensedView>
              <GerenciarConvocados />
            </SuspensedView>
          }
        />

        <Route
          path="/committee-management/categories"
          element={
            <SuspensedView>
              <CategoriasView />
            </SuspensedView>
          }
        />
        <Route
          path="/committee-management/categories/new"
          element={
            <SuspensedView>
              <CategoriasForm />
            </SuspensedView>
          }
        />
        <Route
          path="/committee-management/categories/edit/:id"
          element={
            <SuspensedView>
              <CategoriasForm />
            </SuspensedView>
          }
        />
        <Route
          path="/committee-management/plans"
          element={
            <SuspensedView>
              <PlanosView />
            </SuspensedView>
          }
        />
        <Route
          path="/committee-management/plans/new"
          element={
            <SuspensedView>
              <PlanosForm />
            </SuspensedView>
          }
        />
        <Route
          path="/committee-management/plans/edit/:id"
          element={
            <SuspensedView>
              <PlanosForm />
            </SuspensedView>
          }
        />

        <Route
          path="/technical-committee/evaluations/new"
          element={
            <SuspensedView>
              <AvaliacaoForm />
            </SuspensedView>
          }
        />
        <Route
          path="/technical-committee/athletes/edit/:id"
          element={
            <SuspensedView>
              <AthleteCreate />
            </SuspensedView>
          }
        />

        <Route
          path="/technical-committee/athletes/finances/:id"
          element={
            <SuspensedView>
              <AthleteCreate />
            </SuspensedView>
          }
        />

        <Route
          path="/technical-committee/athletes/contracts/:id"
          element={
            <SuspensedView>
              <AthleteCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/technical-committee/evaluations/edit/:id"
          element={
            <SuspensedView>
              <AvaliacaoForm />
            </SuspensedView>
          }
        />
        <Route
          path="/sponsor"
          element={
            <SuspensedView>
              <SponsorList />
            </SuspensedView>
          }
        />
        <Route
          path="/fornecedores"
          element={
            <SuspensedView>
              <FornecedoresList />
            </SuspensedView>
          }
        />
        <Route
          path="/fornecedores/create"
          element={
            <SuspensedView>
              <FornecedoresForm />
            </SuspensedView>
          }
        />
        <Route
          path="/fornecedores/:id"
          element={
            <SuspensedView>
              <FornecedoresForm />
            </SuspensedView>
          }
        />
        <Route
          path="/estoque"
          element={
            <SuspensedView>
              <EstoqueList />
            </SuspensedView>
          }
        />
        <Route
          path="/estoque/setores"
          element={
            <SuspensedView>
              <SetoresPage />
            </SuspensedView>
          }
        />
        <Route
          path="/estoque/entrada-manual"
          element={
            <SuspensedView>
              <EntradaManualPage />
            </SuspensedView>
          }
        />
        <Route
          path="/estoque/entrada-xml"
          element={
            <SuspensedView>
              <EntradaXmlPage />
            </SuspensedView>
          }
        />
        <Route
          path="/estoque/saida"
          element={
            <SuspensedView>
              <SaidaPage />
            </SuspensedView>
          }
        />
        <Route
          path="/estoque/relatorio"
          element={
            <SuspensedView>
              <RelatorioPage />
            </SuspensedView>
          }
        />
        <Route
          path="/cardapio/pedido"
          element={
            <SuspensedView>
              <CardapioPedidoPage />
            </SuspensedView>
          }
        />
        <Route
          path="/cardapio/cliente"
          element={
            <SuspensedView>
              <CardapioClientePage />
            </SuspensedView>
          }
        />
        <Route
          path="/cardapio/relatorio"
          element={
            <SuspensedView>
              <CardapioRelatorioPage />
            </SuspensedView>
          }
        />
        <Route
          path="/cardapio/create"
          element={
            <SuspensedView>
              <CardapioForm />
            </SuspensedView>
          }
        />
        <Route
          path="/cardapio/:id"
          element={
            <SuspensedView>
              <CardapioForm />
            </SuspensedView>
          }
        />
        <Route
          path="/cardapio"
          element={
            <SuspensedView>
              <CardapioList />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro/abertura"
          element={
            <SuspensedView>
              <AberturaCaixaPage />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro/frente"
          element={
            <SuspensedView>
              <FrenteCaixaPage />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro/fechamento"
          element={
            <SuspensedView>
              <FechamentoCaixaPage />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro/sangria"
          element={
            <SuspensedView>
              <SangriaPage />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro/transacoes"
          element={
            <SuspensedView>
              <TransacoesPage />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro/pagamentos"
          element={
            <SuspensedView>
              <PagamentosPage />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro/pulseiras"
          element={
            <SuspensedView>
              <PulseirasPage />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro/operadores"
          element={
            <SuspensedView>
              <OperadoresPage />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro/comissoes"
          element={
            <SuspensedView>
              <ComissoesPage />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro/relatorios"
          element={
            <SuspensedView>
              <RelatoriosCaixaPage />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro/auditoria"
          element={
            <SuspensedView>
              <AuditoriaPage />
            </SuspensedView>
          }
        />
        <Route
          path="/caixa-financeiro"
          element={
            <SuspensedView>
              <CaixaDashboardPage />
            </SuspensedView>
          }
        />
        <Route
          path="/sponsor/new"
          element={
            <SuspensedView>
              <SponsorForm />
            </SuspensedView>
          }
        />
        <Route
          path="/sponsor/edit/:id"
          element={
            <SuspensedView>
              <SponsorForm />
            </SuspensedView>
          }
        />
        <Route
          path="/sponsor/media/:id"
          element={
            <SuspensedView>
              <SponsorForm />
            </SuspensedView>
          }
        />
        <Route
          path="/sponsor/:id/media"
          element={
            <SuspensedView>
              <SponsorForm />
            </SuspensedView>
          }
        />
        <Route path="/sponsor-management/plans" element={<SponsorPlan />} />
        <Route
          path="/sponsor-management/plans/new"
          element={<SponsorPlanForm />}
        />
        <Route
          path="/sponsor-management/plans/:id"
          element={<SponsorPlanForm />}
        />
        <Route
          path="/generalaccess"
          element={
            <SuspensedView>
              <GeneralAccessList />
            </SuspensedView>
          }
        />
        <Route
          path="/invoicingpayments"
          element={
            <SuspensedView>
              <InvoicingPaymentsList />
            </SuspensedView>
          }
        />
        <Route
          path="/roles"
          element={
            <SuspensedView>
              <RolesList />
            </SuspensedView>
          }
        />
        <Route
          path="/roles/create"
          element={
            <SuspensedView>
              <RolesCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/roles/:id"
          element={
            <SuspensedView>
              <RolesEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/roles/:id/permissions"
          element={
            <SuspensedView>
              <RolePermissions />
            </SuspensedView>
          }
        />

        {/* 🟢 CORREÇÃO: Rotas globais de contratos ativadas */}
        <Route
          path="/contracts"
          element={
            <SuspensedView>
              <ContractsList />
            </SuspensedView>
          }
        />
        <Route
          path="/contracts/create"
          element={
            <SuspensedView>
              <ContractsCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/contracts/:id"
          element={
            <SuspensedView>
              <ContractsEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/contracts/:contractId/charges"
          element={
            <SuspensedView>
              <ChargesList />
            </SuspensedView>
          }
        />

        <Route
          path="/locations"
          element={
            <SuspensedView>
              <LocationsList />
            </SuspensedView>
          }
        />
        <Route
          path="/locations/create"
          element={
            <SuspensedView>
              <LocationsCreate />
            </SuspensedView>
          }
        />

        <Route
          path="/locations/:locationId"
          element={
            <SuspensedView>
              <LocationsEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/plans"
          element={
            <SuspensedView>
              <PlansList />
            </SuspensedView>
          }
        />
        <Route
          path="/plans/create"
          element={
            <SuspensedView>
              <PlansCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/plans/:id"
          element={
            <SuspensedView>
              <PlansEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/plans/:id/discount-coupons"
          element={
            <SuspensedView>
              <PlansDiscountCoupons />
            </SuspensedView>
          }
        />
        <Route
          path="/permissions"
          element={
            <SuspensedView>
              <PermissionsList />
            </SuspensedView>
          }
        />
        <Route
          path="/permissions/create"
          element={
            <SuspensedView>
              <PermissionsCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/permissions/:id"
          element={
            <SuspensedView>
              <PermissionsEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/discount-coupons"
          element={
            <SuspensedView>
              <DiscountCouponsList />
            </SuspensedView>
          }
        />
        <Route
          path="/discount-coupons/create"
          element={
            <SuspensedView>
              <DiscountCouponsCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/discount-coupons/:id"
          element={
            <SuspensedView>
              <DiscountCouponsEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/discounts"
          element={
            <SuspensedView>
              <DiscountsList />
            </SuspensedView>
          }
        />
        <Route
          path="/discounts/create"
          element={
            <SuspensedView>
              <DiscountsCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/discounts/:id"
          element={
            <SuspensedView>
              <DiscountsEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/templates"
          element={
            <SuspensedView>
              <TemplatesList />
            </SuspensedView>
          }
        />
        <Route
          path="/templates/create"
          element={
            <SuspensedView>
              <TemplatesCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/templates/:id"
          element={
            <SuspensedView>
              <TemplatesEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/tags"
          element={
            <SuspensedView>
              <TagsList />
            </SuspensedView>
          }
        />
        <Route
          path="/tags/create"
          element={
            <SuspensedView>
              <TagsCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/tags/:id"
          element={
            <SuspensedView>
              <TagsEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/templates/:id/tags"
          element={
            <SuspensedView>
              <TemplateTags />
            </SuspensedView>
          }
        />
        <Route
          path="/modules"
          element={
            <SuspensedView>
              <ModulesList />
            </SuspensedView>
          }
        />
        <Route
          path="/profile"
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path="/modules/create"
          element={
            <SuspensedView>
              <ModulesCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/modules/:id"
          element={
            <SuspensedView>
              <ModulesEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/locations/:locationId/sections"
          element={
            <SuspensedView>
              <SectionsList />
            </SuspensedView>
          }
        />
        <Route
          path="/locations/:locationId/sections/create"
          element={
            <SuspensedView>
              <SectionsCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/locations/:locationId/sections/:id"
          element={
            <SuspensedView>
              <SectionsEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/bracelet-colors"
          element={
            <SuspensedView>
              <BraceletColorsList />
            </SuspensedView>
          }
        />
        <Route
          path="/bracelet-colors/create"
          element={
            <SuspensedView>
              <BraceletColorsCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/bracelet-colors/:braceletColorId"
          element={
            <SuspensedView>
              <BraceletColorsEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/bracelet-colors/:id/sections"
          element={
            <SuspensedView>
              <BraceletColorsSections />
            </SuspensedView>
          }
        />
        <Route
          path="/bracelet-colors/:id/locations"
          element={
            <SuspensedView>
              <BraceletColorsLocations />
            </SuspensedView>
          }
        />
        <Route
          path="/users/:userId/bracelets"
          element={
            <SuspensedView>
              <BraceletsList />
            </SuspensedView>
          }
        />
        <Route
          path="/users/:userId/bracelets/create"
          element={
            <SuspensedView>
              <BraceletsCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/users/:userId/bracelets/:id"
          element={
            <SuspensedView>
              <BraceletsEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/users/:id/addresses/"
          element={
            <SuspensedView>
              <AddressesList />
            </SuspensedView>
          }
        />
        <Route
          path="/users/:id/addresses/create"
          element={
            <SuspensedView>
              <AddressCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/users/:userId/addresses/:id"
          element={
            <SuspensedView>
              <AddressEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/locations/:locationId/sections/:sectionId/access-points"
          element={
            <SuspensedView>
              <AccessPointsList />
            </SuspensedView>
          }
        />
        <Route
          path="/locations/:locationId/sections/:sectionId/access-points/create"
          element={
            <SuspensedView>
              <AccessPointsCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/locations/:locationId/sections/:sectionId/access-points/:id"
          element={
            <SuspensedView>
              <AccessPointsEdit />
            </SuspensedView>
          }
        />

        <Route
          path="/employees"
          element={
            <SuspensedView>
              <EmployeesList />
            </SuspensedView>
          }
        />
        <Route
          path="/employees/create"
          element={
            <SuspensedView>
              <EmployeesCreate />
            </SuspensedView>
          }
        />
        <Route
          path="/employees/:id"
          element={
            <SuspensedView>
              <EmployeesEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/employees/:id/roles"
          element={
            <SuspensedView>
              <EmployeeRoles />
            </SuspensedView>
          }
        />
        <Route
          path="/employees/:id/permissions"
          element={
            <SuspensedView>
              <UserPermissions />
            </SuspensedView>
          }
        />
        <Route
          path="/employees/:id/addresses"
          element={
            <SuspensedView>
              <AddressesList />
            </SuspensedView>
          }
        />
        <Route
          path="/employees/:userId/addresses/:id"
          element={
            <SuspensedView>
              <AddressEdit />
            </SuspensedView>
          }
        />
        <Route
          path="/employees/:id/addresses/create"
          element={
            <SuspensedView>
              <AddressCreate />
            </SuspensedView>
          }
        />
        {/* 🟢 CORREÇÃO: Rotas de contratos do funcionário ativadas */}
        <Route
          path="/employees/:userId/contracts"
          element={
            <SuspensedView>
              <ContractsList />
            </SuspensedView>
          }
        />
        <Route
          path="/employees/:id/locations"
          element={
            <SuspensedView>
              <UserLocations />
            </SuspensedView>
          }
        />
        <Route
          path="/employees/:userId/bracelets"
          element={
            <SuspensedView>
              <BraceletsList />
            </SuspensedView>
          }
        />
        {/* Financeiro - Contas a Pagar e Receber */}
        <Route
          path="/financeiro"
          element={<Navigate to="/financeiro/contas-pagar" replace />}
        />
        <Route
          path="/financeiro/plano-contas"
          element={
            <SuspensedView>
              <PlanoContasPage />
            </SuspensedView>
          }
        />
        <Route
          path="/financeiro/centros-custo"
          element={
            <SuspensedView>
              <CentrosCustoPage />
            </SuspensedView>
          }
        />
        <Route
          path="/financeiro/contas-pagar"
          element={
            <SuspensedView>
              <ContasPagarList />
            </SuspensedView>
          }
        />
        <Route
          path="/financeiro/contas-pagar/nova"
          element={
            <SuspensedView>
              <EntradaContaPagarPage />
            </SuspensedView>
          }
        />
        <Route
          path="/financeiro/contas-receber"
          element={
            <SuspensedView>
              <ContasReceberList />
            </SuspensedView>
          }
        />
        <Route
          path="/financeiro/contas-receber/nova"
          element={
            <SuspensedView>
              <EntradaContaReceberPage />
            </SuspensedView>
          }
        />
        <Route
          path="/financeiro/fluxo-caixa"
          element={
            <SuspensedView>
              <FluxoCaixaPage />
            </SuspensedView>
          }
        />
        <Route
          path="/financeiro/conciliacao"
          element={
            <SuspensedView>
              <ConciliacaoBancariaPage />
            </SuspensedView>
          }
        />
        <Route
          path="/financeiro/dre"
          element={
            <SuspensedView>
              <DreSimplificadaPage />
            </SuspensedView>
          }
        />
        <Route
          path="/financeiro/relatorios"
          element={
            <SuspensedView>
              <RelatoriosGerenciaisPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue("--bs-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };